const SUPPORT_NOTICE_KEY = "__i18next_supportNoticeShown";

/**
 * `i18next` (a transitive dependency of `stream-chat-react`) logs a
 * `console.info` advert for Locize the first time an instance is initialised.
 * `stream-chat-react` builds its own instance internally, so there is no
 * `showSupportNotice: false` option we can pass through. i18next also skips the
 * notice when it has already been shown, which it tracks with a flag on
 * `globalThis` — setting that flag before chat mounts suppresses the advert.
 */
export function silenceI18nextSupportNotice(): void {
    Object.defineProperty(globalThis, SUPPORT_NOTICE_KEY, {
        value: true,
        writable: true,
        configurable: true,
    });
}
